const saveQuoteMessage = (saveType, email) => {
  const messageObj = {
    initial: {
      title: "",
      message: "",
    },
    success: {
      title: "",
      message: "",
    }
  }
  switch(saveType) {
    case "referral":
      messageObj.initial.title = "Almost there!";
      messageObj.initial.message = "We're getting your quotes ready! Enter your name and email to save your progress and access your quotes anytime.";
      messageObj.success.title = "We sent you a link!";
      messageObj.success.message = `Your saved quote was sent to ${email}.`;
      break;
    default:
      break;
  }

  return messageObj;
}

export { saveQuoteMessage };